import ApiRegions from '../../api/regions';

const setSelectedRegion = region => {
    return {
        type: 'SET_SELECTED_REGION',
        payload: region
    }
}

const getRegionsStarted = () => ({
    type: 'GET_REGIONS_STARTED'
});

const getRegionsSuccess = items => ({
    type: 'GET_REGIONS_SUCCESS',
    payload: items
});

const getRegionsFailure = error => ({
    type: 'GET_REGIONS_FAILURE',
    payload: { error }
});

const getRegions = () => {

    return dispatch => {

        dispatch(getRegionsStarted());

        ApiRegions.get()
            .then(json => { 
                const items = json.regions;
                dispatch(getRegionsSuccess({ items }));
                // if (items.length > 0) {
                //     dispatch(setSelectedRegion(items[0]))
                // }
            })
            .catch(error => dispatch(getRegionsFailure(error)));            

    }
    
}

export default { setSelectedRegion, getRegions }